import Vue from 'vue';
import Router from 'vue-router';
import $store from '../store/index';
import { getUserInfo } from '@/Api/files';
import { gatewayUrl, environment } from '@/assets/js/config';
import Tool from '@/assets/js/common/utils.js';

// 防止路由跳转同名路由的时候报错
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

// 按需加载书写形式
const RecordedFiles = () => import('@/Views/RecordedFiles/RecordedFiles');

const RemoteRecordedFiles = () =>
  import('@/Views/RecordedFiles/RemoteRecordedFiles');

// Load marker files
// const MarkerFiles = () => import("@/Views/MarkerFiles/");

Vue.use(Router);
const routes = [
  {
    path: '/',
    name: () => {
      if ($store.state.isRemoteRecordingFeatureEnabled) {
        return 'RemoteRecordedFiles'
      } else {
        return 'RecordedFiles'
      }
    },
    component: () => {
      if ($store.state.isRemoteRecordingFeatureEnabled) {
        return import('@/Views/RecordedFiles/RemoteRecordedFiles');
      } else {
        return import('@/Views/RecordedFiles/RecordedFiles');
      }
    }
  },
  {
    path: '/rf',
    name: 'RecordedFiles',
    component: RecordedFiles,
  },
  {
    path: '/rr',
    name: 'RemoteRecordedFiles',
    component: RemoteRecordedFiles,
  }
];
const router = new Router({
  mode: 'history',
  routes,
  linkExactActiveClass: 'tabActive',
});

async function getUserInfoF() {
  // 获取用户信息
  const res = await getUserInfo();
  if (res.data.errorCode == '0x0') {
    const userInfo = res.data.result;
    $store.dispatch('commitUserInfo', res.data.result);
    if (environment && environment === 'prod') {
      if (userInfo?.id) await loadUserFeature(userInfo.id);
    } else {
      $store.dispatch('commitRemoteRecordingFeature', true);
    }
  }
}

async function loadUserFeature(userId) {
  $.ajax({
    url: `${gatewayUrl}/newpp/user/feature/all-features/` + userId,
    type: 'get',
    async: false,
    headers: { Authorization: Tool.getCookie() },
    success(data) {
      // eslint-disable-next-line no-cond-assign,no-constant-condition
      if ((data.errorCode = '0x0')) {
        const result = data.result;
        if (result.remoteRecording) {
          $store.dispatch(
            'commitRemoteRecordingFeature',
            result.remoteRecording
          );
        } else {
          $store.dispatch('commitRemoteRecordingFeature', false);
        }
      }
    },
    error: function(error) {
      $store.dispatch('commitRemoteRecordingFeature', false);
    },
  });
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    // console.log(to.meta.title)
  }
  if (!$store.state.userInfo.id) {
    const res = await getUserInfoF();
  }
  $store.dispatch('commitConfigInfo'); // 获取配置
  next();
});

export default router;
